import React from "react";
import { motion } from "framer-motion";
import "../../style/NavBar.css";

const Path = (props) => (
  <motion.path
    fill="transparent"
    strokeWidth="2"
    stroke={props.color}
    strokeLinecap="round"
    {...props}
  />
);

function NavBarToggle({ toggle, color }) {
  return (
    <button
      className="custom-button-navbar navbar-toggle white"
      onClick={toggle}
    >
      <svg width="23" height="23" viewBox="0 0 23 23">
        <Path
          variants={{
            closed: { d: "M 2 2.5 L 20 2.5" },
            open: { d: "M 3 16.5 L 17 2.5" },
          }}
          color={color}
        />
        <Path
          d="M 2 9.423 L 20 9.423"
          variants={{
            closed: { opacity: 1 },
            open: { opacity: 0 },
          }}
          transition={{ duration: 0.1 }}
          color={color}
        />
        <Path
          variants={{
            closed: { d: "M 2 16.346 L 20 16.346" },
            open: { d: "M 3 2.5 L 17 16.346" },
          }}
          color={color}
        />
      </svg>
    </button>
  );
}

export default NavBarToggle;
